import React, {useEffect, useState} from "react";
import {VsiBubble, VsiH4} from "../../../../styled/App.styled";
import BarChart from "../../../../components/BarChart";
import Grid from "../../../../components/Grid";
import {useDataWithRoute, useTitleFromComponent} from "../../../../utils/hooks";
import {useSearchParams} from "react-router-dom";
import {useVsiAppContext} from "../../../../stores/VsiApp";
import {Card} from "reactstrap";

const categories = ['Connected', 'Missing'];
export default function ISLPortAnalysis({context, title}) {
    const [searchParams] = useSearchParams();
    const switchName = decodeURIComponent(searchParams.get('switch_name') || 'N/A');
    useTitleFromComponent(`${switchName} ${context} / ${title}`);
    const { theme, client } = useVsiAppContext();

    const [chartSeries, setChartSeries] = useState([]);

    const [{recordset: allData}] = useDataWithRoute(`/api/v6/report/switch_isl_port_analysis_proc?switch_name=${encodeURIComponent(switchName)}&client_id=${client.clientId}&period_id=${searchParams.get('period_id')}`)

    useEffect(() => {
        setChartSeries([
            {
                data: categories.map(cat => [cat.toLowerCase() === 'connected' ? (allData?.[0]?.isl_connected ?? 0) : (allData?.[0]?.isl_missing ?? 0)])
            }
        ]);
    }, [allData]);
    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>ISL Port Analysis - {switchName}</VsiH4>
            <VsiBubble className={"mb-2"}>
                <BarChart categories={categories}
                          disableLegend={true}
                          yAxisTitle={"ISL"}
                          series={chartSeries}/>
            </VsiBubble>
            <VsiBubble>
            <Grid data={allData || []}
                  columnDefs={[
                      {
                          "field": "isl_connected",
                          "headerName": "Connected",
                          "type": "numericColumn",
                      },
                      {
                          "field": "isl_missing",
                          "headerName": "Missing",
                          "type": "numericColumn",
                      },
                      {
                          "field": "isl_count",
                          "headerName": "Count",
                          "type": "numericColumn",
                      },
                  ]}/>
            </VsiBubble>
        </Card>
    )
}
